import React from 'react';
const helpMessage = (<>
    Si tiene alguna pregunta sobre sus cuentas, por favor{' '}
    <a className='hui-link customer-search-inline-link' href='mailto:CCS_Product_Portal_Services@lfg.com'>envíenos un correo electrónico.</a>
  </>);
const errorMessage = (<>
    No podemos recuperar la lista de clientes en este momento. Por favor, vuelva de nuevo en 20 minutos. Si este
    problema persiste, <a className='hui-link customer-search-inline-link' href='mailto:CCS_Product_Portal_Services@lfg.com'>envíenos un correo electrónico.</a>
  </>);
const unassociatedMessage = (<>
    <p>
      Gracias por registrarte en <strong>My Lincoln Portal</strong>. Estamos trabajando activamente para asociar su
      libro de negocios. ¡Por favor, revise luego!
    </p>
    <p>
      Si tiene alguna pregunta, por favor{' '}
      <a className='hui-link customer-search-inline-link' href='mailto:CCS_Product_Portal_Services@lfg.com'>envíenos un correo electrónico.</a>
    </p>
  </>);
export const MultiCustomerDisplayTextEs = {
    pageHeading: 'Mis cuentas de cliente(s)',
    subHeading: 'Para ver información de una cuenta específica, busque por nombre de cuenta o div-serial.',
    customerHeading: 'Resultados de búsqueda de clientes',
    searchLabel: 'Buscar',
    searchPlaceholder: 'Buscar',
    searchPlaceholderFocused: 'Busque por nombre del cliente, al menos 3 caracteres',
    performanceMessage: 'Para mejorar el rendimiento del sitio, su lista de clientes aparecerá solo después de ingresar criterios de búsqueda.',
    rowLabel: 'clientes',
    helpMessage,
    noResults: 'No se han encontrado resultados.',
    errorMessage,
    unassociatedMessage,
};
